/**
 * Building.ts
 * Placeable structure. Occupies tiles, may generate resources or defend.
 */

import { Entity } from './Entity';
import type { GridPosition } from '../types';

export class Building extends Entity {
  footprint: GridPosition[] = [];
  maxHp = 100;
  hp = 100;
  constructed = false; // false while under construction

  update(delta: number): void {
    // TODO: progress construction, tick resource generation / defensive behaviour.
  }
}
